<style lang="scss">
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/mixins";

  span {
    position: relative;

    > .badge {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      @include mixins.body4-badge();

      &.raised {
        position: absolute;
        top: utils.in_rem(-6px);
      }
      &.inline {
        position: relative;
      }

      &.position-right {
        right: utils.in_rem(-6px);
      }

      &.position-inner-right {
        right: utils.in_rem(6px);
      }

      &.position-left {
        left: utils.in_rem(-6px);
      }

      &.position-inner-left {
        left: utils.in_rem(6px);
      }

      &.position-center {
        left: 50%;
        transform: translateX(-50%);
      }

      &.position-tab {
        top: unset;
        right: 0;
        bottom: 0;
      }

      &.brand-low {
        @include colors.background-color(primary_5);
        @include colors.color(primary_50);
      }

      &.brand-high {
        @include colors.background-color(primary_50);
        @include colors.color(textWhite);
      }

      &.trial-high {
        background-color: #ff99d9;
        @include colors.color(primary_70);
      }

      &.number-low {
        @include colors.background-color(accentNotificationTextLightPink);
        @include colors.color(accentNotificationSurfacePink);
      }

      &.number-high {
        @include colors.background-color(accentNotificationSurfacePink);
        @include colors.color(textWhite);
      }

      &.number-impersonate {
        @include colors.background-color(
          accentNotificationImpersonateSurfaceYellow
        );
        @include colors.color(accentNotificationImpersonateTextRed);
      }

      &.number-yellow {
        @include colors.background-color(accentNotificationYellow);
        @include colors.color(textBlack);
      }

      &.number-clear {
        background-color: transparent;
        @include colors.color(textBlack);
      }

      &.number-disabled {
        @include colors.background-color(interfaceDisabledGrey_5);
        @include colors.color(textDisabledGrey);
      }

      &.number-new {
        @include colors.background-color(accentStatusSeaGreen);
        @include colors.color(primary_70);
      }

      &.number-trial {
        @include colors.background-color(accentTrialPink);
        @include colors.color(primary_70);
      }

      &.system-low {
        @include colors.background-color(interfaceSwGrey_10);
        @include colors.color(textBlack);
      }

      &.system-high {
        @include colors.background-color(interfaceSwShadowGrey);
        @include colors.color(textWhite);
      }

      &.small {
        height: utils.in_rem(6px);
        width: utils.in_rem(6px);
      }

      &.large {
        min-height: utils.in_rem(14px);
        min-width: utils.in_rem(14px);
        padding: utils.in_rem(1px) utils.in_rem(4px);
      }

      &.large:after {
        content: attr(data-value);
        width: 100%;
        height: 100%;
      }
    }
  }
</style>

<script>
  export let value;
  export let size = "large"; // "small" | "large"
  export let type = "number"; // "brand" | "number" | "system"
  export let contrast = "high"; // "low" | "high" | "impersonate" | "yellow" | "disabled"
  export let position = "right"; // "left" | "right" | "center"
  export let inline = false; // For the vertical position

  $: raised = !inline;
</script>

{#if value}
  <span>
    <slot />
    <div
      class="badge position-{position} {type}-{contrast} {size}"
      class:raised
      class:inline
      data-value={value}
    ></div>
  </span>
{:else}
  <slot />
{/if}
